



















import LayoutSidebar from "@/components/layouts/LayoutSidebar.vue";
import CacheSidebar from "@/components/CacheSidebar.vue";
import PromoBanner from "@/components/PromoBanner.vue";
import { DataStatus } from "@/types/common";
import { Component, Vue, Watch } from "vue-property-decorator";
import { State, Getter } from "vuex-class";

@Component({ components: { LayoutSidebar, CacheSidebar, PromoBanner } })
export default class CacheView extends Vue {
  created() {
    // fetch on component creation
    this.fetchCacheData();
  }

  @State("activeCacheID") activeCacheID!: number;

  @Getter("settings/activeCacheSettingsStatus") settingsStatus!: DataStatus;
  @Getter("settings/activeCacheFeaturesStatus") featuresStatus!: DataStatus;

  @Watch("activeCacheID")
  onCacheIDUpdate() {
    // fetch on cache ID update, because the component is not re-rendered
    // on param change so lifecycle hooks will not be called
    this.fetchCacheData();
  }

  fetchCacheData() {
    // reset state when switching cache so previous cache data
    // does not remain if fetching fails
    this.$store.dispatch("stats/resetState");
    this.$store.dispatch("processedStats/resetState");

    this.$store.dispatch("settings/fetch");
    this.$store.dispatch("settings/fetchFeatures");
  }
}
